<template>
	<div class="rb-comment-composer mt-4">
		<div data-augmented-ui="both tl-clip br-2-clip-y">
			<textarea
				class="comment-textarea"
				v-model="text" :disabled="savingComment"
				v-textarea-grow
			></textarea>
		</div>

		<div class="mt-3">
			<span class="text-xs" style="opacity: .4">
				Formatação:
				<i>*itálico*</i>,
				<b>**negrito**</b>
			</span>

			<rb-button
				variant="primary" size="sm" class="float-right"
				:disabled="savingComment || text.length < MIN_LENGTH" @click="send">
				Enviar
			</rb-button>

			<div class="clear"></div>
		</div>
	</div>
</template>

<script>
	import {Video, VideoComment} from '../../../../shared/entities/Video';
	import { textareaGrow } from './textareaGrow';
	import RbButton from '../RbButton';

	const MIN_LENGTH = 2;

	export default {
		name: 'RbCommentComposer',
		components: { RbButton },
		data: () => ({
			text: '',
			savingComment: false,
			MIN_LENGTH
		}),
		props: {
			/** @type {Video} **/
			video: {
				type: Video,
				required: true
			},
			/** @type {VideoComment} **/
			parent: {
				default: null
			}
		},
		directives: {
			textareaGrow
		},
		methods: {
			async send() {
				if (!this.text) return;

				try {
					this.savingComment = true;
					const comment = await this.$oldApi.Video.addComment(
						this.video.Id,
						this.text,
						this.parent ? this.parent.Id : 0
					);
					this.text = '';
					this.savingComment = false;

					this.$emit('sent');

					if (this.parent) {
						this.parent.Comments.splice(0,0, new VideoComment(comment));
					} else {
						this.video.Comments.splice(0,0, new VideoComment(comment));
					}
				} catch (e) {
					alert("Ops, algo deu errado...");
					this.savingComment = false;
				}
			},
		}
	}
</script>

<style lang="scss" scoped>
	.comment-textarea {
		background: none;
		border: none;
		width: 100%;
		padding: 10px 18px;
		margin-top: 4px;
		resize: none;
		min-height: 90px;
	}
	.clear {
		clear: both;
	}
</style>
